/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Intake_Why_Session_Hard_Limit_ShortInputs */

const en_us2_intake_why_session_hard_limit_short = /** @type {(inputs: Intake_Why_Session_Hard_Limit_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Decides what gets cut`)
};

const pt_br2_intake_why_session_hard_limit_short = /** @type {(inputs: Intake_Why_Session_Hard_Limit_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Decide o que é cortado`)
};

const es_419_intake_why_session_hard_limit_short = /** @type {(inputs: Intake_Why_Session_Hard_Limit_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Decide qué se recorta`)
};

const pt_pt2_intake_why_session_hard_limit_short = /** @type {(inputs: Intake_Why_Session_Hard_Limit_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Decide o que é cortado`)
};

const fr_fr2_intake_why_session_hard_limit_short = /** @type {(inputs: Intake_Why_Session_Hard_Limit_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Décide de ce qui est coupé`)
};

const de_de2_intake_why_session_hard_limit_short = /** @type {(inputs: Intake_Why_Session_Hard_Limit_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entscheidet, was gekürzt wird`)
};

const it_it2_intake_why_session_hard_limit_short = /** @type {(inputs: Intake_Why_Session_Hard_Limit_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Decide cosa si taglia`)
};

/**
* | output |
* | --- |
* | "Decides what gets cut" |
*
* @param {Intake_Why_Session_Hard_Limit_ShortInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const intake_why_session_hard_limit_short = /** @type {((inputs?: Intake_Why_Session_Hard_Limit_ShortInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intake_Why_Session_Hard_Limit_ShortInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_intake_why_session_hard_limit_short(inputs)
	if (locale === "es-419") return es_419_intake_why_session_hard_limit_short(inputs)
	if (locale === "pt-PT") return pt_pt2_intake_why_session_hard_limit_short(inputs)
	if (locale === "fr-FR") return fr_fr2_intake_why_session_hard_limit_short(inputs)
	if (locale === "de-DE") return de_de2_intake_why_session_hard_limit_short(inputs)
	if (locale === "it-IT") return it_it2_intake_why_session_hard_limit_short(inputs)
	return en_us2_intake_why_session_hard_limit_short(inputs)
});
export { intake_why_session_hard_limit_short as "intake.why.session_hard_limit.short" }